import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { AppState } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables, GlobalRef } from '../../../common/global-variables';
import ServicesMain from './services-main.component';
import { VcaAlertsService } from '../../../common/vca-alerts/vca-alerts.service';
import { AuthService } from '../../auth/auth.service';
import { AUTH_CONSTANTS } from '../../auth/auth-constants';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../refresh-shared-service';
import { storagePrettyConverter, checkIfUserHasRoles } from '../../../common/utils/utils';
import { GuidedTour, GuidedTourBuilder } from '../../../app/services/guided-tour-builder/guided-tour-builder.service';

export const SERVICES_OVERVIEW_TOUR_ID = 'services.overview';

export class ServicesGuidedTourData {

    private overviewTour;

    constructor(
        private translate: TranslateService,
        private authService: AuthService,
        private services: ServicesMain,
        private globalRef: GlobalRef,
        private guidedTourBuilder: GuidedTourBuilder) {

            this.guidedTourBuilder.createTour(SERVICES_OVERVIEW_TOUR_ID,
                ()=> {console.debug('Tour was Started')},
                ()=> {console.debug('Tour was Canceled');
                    this.blockOverviewTourOnNextSession();
                    },
                ()=> {console.debug('Tour was Completed');
                    this.blockOverviewTourOnNextSession();
                    }
            );

        }


    /*
     * - - - - - Building 'overview' tour for the 'Services' tab - - - - - - - - -
     */

    /**
     * JQuery Elements:
     *
     *  #header_nav_services
     *  services_compute
        services_vc_networking
        services_vcd_networks
        services_dataprotection
        services_disaster_recovery
     */
    buildOverviewGuidedTour() {
        this.overviewTour = this.guidedTourBuilder.findTour(SERVICES_OVERVIEW_TOUR_ID);
        let allSteps = {
            step_0: {
                title: this.translate.instant('guidedTour.services.splash.head'),
                text: this.translate.instant('guidedTour.services.splash.mesg'),
                attachTo: {element:'#header_nav_services', on:'bottom'},
                classes: 'guided-tour',
                buttons: [
                    {
                        text: 'Start Tour',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    },
                    {
                        text: 'Skip',
                        classes: 'shepherd-button-secondary btn-link',
                        action: () => this.overviewTour.cancel()
                    }
                    ]
                },
            step_1: {
                title: this.translate.instant('guidedTour.services.overview.computes.head'),
                text: this.translate.instant('guidedTour.services.overview.computes.mesg'),
                attachTo: {element:'#services_compute', on: 'right'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_vc2: {
                title: this.translate.instant('guidedTour.services.overview.vcNetworking.head'),
                text: this.translate.instant('guidedTour.services.overview.vcNetworking.mesg'),
                attachTo: {element:'#services_vc_networking', on: 'right'},
                classes: 'guided-tour',
                buttons: [
                    {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_vcd2: {
                title: this.translate.instant('guidedTour.services.overview.vcdNetworks.head'),
                text: this.translate.instant('guidedTour.services.overview.vcdNetworks.mesg'),
                attachTo: {element:'#services_vcd_networks', on: 'right'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_3: {
                title: this.translate.instant('guidedTour.services.overview.dataProtection.head'),
                text: this.translate.instant('guidedTour.services.overview.dataProtection.mesg'),
                attachTo: {element:'#services_dataprotection', on: 'right'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_4: {
                title: this.translate.instant('guidedTour.services.overview.disasterRecovery.head'),
                text: this.translate.instant('guidedTour.services.overview.disasterRecovery.mesg'),
                attachTo: {element:'#services_disaster_recovery', on: 'right'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Finish',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                }
        };

        this.guidedTourBuilder.addStep(SERVICES_OVERVIEW_TOUR_ID, 'step_0', allSteps['step_0']);
        this.guidedTourBuilder.addStep(SERVICES_OVERVIEW_TOUR_ID, 'step_1', allSteps['step_1']);
        if(this.authService.VREALM_TYPE === AUTH_CONSTANTS.VC) {
            this.guidedTourBuilder.addStep(SERVICES_OVERVIEW_TOUR_ID, 'step_vc2', allSteps['step_vc2']);
        }
        if(this.authService.VREALM_TYPE === AUTH_CONSTANTS.VCD) {
            this.guidedTourBuilder.addStep(SERVICES_OVERVIEW_TOUR_ID, 'step_vcd2', allSteps['step_vcd2']);
        }
        this.guidedTourBuilder.addStep(SERVICES_OVERVIEW_TOUR_ID, 'step_3', allSteps['step_3']);
        this.guidedTourBuilder.addStep(SERVICES_OVERVIEW_TOUR_ID, 'step_4', allSteps['step_4']);
    }

    private blockOverviewTourOnNextSession() {
        this.globalRef.setShowHcxServicesOverviewTour = false;
    }

    private isBlockedOverviewTourOnNextSession() : boolean {
        return !this.globalRef.isToShowHcxServicesOverviewTour;
    }

    private ensureOverviewTourOnNextSession() {
        this.globalRef.setShowHcxServicesOverviewTour = true;
    }

    /**
     * Need to save state so, we know if we need to load in the next session or not.
     */
    parkToursAndCleanup() {
        let isOverviewTourAlreadyBlocked = this.isBlockedOverviewTourOnNextSession();
        this.guidedTourBuilder.exitAllTours();
        this.guidedTourBuilder.destroyAllTours();
        if(!isOverviewTourAlreadyBlocked) {
            this.ensureOverviewTourOnNextSession();
        }
    }


    /**
     * This method is idempotent - if the tour is already started,
     * does nothing.
     */
    startOverviewTourIfNotBlocked(){
        if(!this.isBlockedOverviewTourOnNextSession()) {
            console.debug('Starting ', SERVICES_OVERVIEW_TOUR_ID, ' Guided Tour!! ',
                this.guidedTourBuilder.findTour(SERVICES_OVERVIEW_TOUR_ID));
            this.guidedTourBuilder.startTour(SERVICES_OVERVIEW_TOUR_ID);
        } else {
            console.debug('Tour was completed/skipped before, so not starting again: ',
            SERVICES_OVERVIEW_TOUR_ID, ' Guided Tour!!');
        }
    }


    /*
     * - - - - - Building 'Next' tour for the 'Services' - - - - - - - - -
     *
     * // Similarly, add 'build' and 'start' methods for more tours...
     */
}


// WEBPACK FOOTER //
// ./src/app/components/services-main/services-main.guidedtour.data.ts